"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Filtr_1 = require("../../../../components/Filtr/Filtr");
var hooks_1 = require("../../../../hooks");
var BlockDruhyOsob = function (_a) {
    var label = _a.label, value = _a.value;
    var _b = hooks_1.useCiselnik('druhyOsob'), data = _b.data, loading = _b.loading, error = _b.error;
    if (loading) {
        return react_1.default.createElement("div", null, "loading");
    }
    if (error) {
        return react_1.default.createElement("div", null, error);
    }
    var druhyOsob = value.map(function (idDruhOsoby) {
        var osoba = data === null || data === void 0 ? void 0 : data.find(function (d) { return d.id === idDruhOsoby; });
        return osoba === null || osoba === void 0 ? void 0 : osoba.nazev;
    });
    return (react_1.default.createElement("div", null,
        label,
        react_1.default.createElement("br", null),
        druhyOsob.map(function (druh) { return (react_1.default.createElement(Filtr_1.Filtr, { key: druh }, druh)); })));
};
exports.default = BlockDruhyOsob;
